import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavHeader from '../components/NavHeader';
import FooterSection from '../components/FooterSection';
import HeroSection from '../components/landing/HeroSection';
import PillarsSection from '../components/landing/PillarsSection';
import GamesShowcaseSection from '../components/landing/GamesShowcaseSection';
import SummitSpotlightSection from '../components/landing/SummitSpotlightSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import AutoDrawFeatureSection from '../components/landing/AutoDrawFeatureSection';
import LiveStatsTicker from '../components/landing/LiveStatsTicker';
import { captureReferralQueryOnLanding } from '../components/RefLinkCapture';

/**
 * First landing (`/`): referral query params are read here and stored via `persistReferralCode`
 * (through `captureReferralQueryOnLanding`). `/ref` short links are handled in `RefLinkCapture`.
 */
function Home() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/') return;
    captureReferralQueryOnLanding(location.pathname, location.search, navigate);
  }, [location.pathname, location.search, navigate]);

  return (
    <div className="min-h-screen bg-dark">
      <NavHeader />
      <HeroSection />
      <PillarsSection />
      <GamesShowcaseSection />
      <SummitSpotlightSection />
      <HowItWorksSection />
      <AutoDrawFeatureSection />
      <LiveStatsTicker />
      <FooterSection />
    </div>
  );
}

export default Home;
